interface Props {
  steps: string[];      // ["National scope", "+ cross-dataset gap", ...]
  onReset: () => void;
}

export function RefinementHistory({ steps, onReset }: Props) {
  if (steps.length === 0) return null;
  return (
    <div className="dash-drawer">
      <div className="dash-drawer__left">
        <span className="dash-drawer__kicker">REFINEMENT HISTORY</span>
        {steps.map((s, i) => (
          <span
            key={`${s}-${i}`}
            className={i === steps.length - 1 ? 'dash-drawer__step--active' : 'dash-drawer__step'}
          >
            {i + 1}. {s}
            {i < steps.length - 1 && <span className="dash-drawer__arrow"> → </span>}
          </span>
        ))}
      </div>
      <div className="dash-drawer__right">
        <button className="dash-drawer__btn" onClick={onReset}>↶ Reset</button>
        <button className="dash-drawer__btn" onClick={() => alert('Save view coming soon')}>Save view</button>
        <button className="dash-drawer__btn dash-drawer__btn--prim" onClick={() => alert('Export PDF coming soon')}>Export PDF</button>
      </div>
    </div>
  );
}
